import axios from "axios";
import PhoneLoginModal from "../modals/PhoneLoginModal";

let phoneModal = new PhoneLoginModal()

$(document).on('click', '[href="#login"]', event => {
    event.preventDefault()
    requirePhoneCode().then(result => login(result))
})

function setTimer(seconds) {
    let timerInterval = setInterval(function () {
        if (seconds > 0) {
            phoneModal.resendCodeTimerElement.innerHTML = `(${seconds--})`
        } else {
            phoneModal.resendCodeTimerElement.innerHTML = ''
            clearInterval(timerInterval)
        }
    }, 1000)
    phoneModal.showResendCodeButton()
}

function sendPhoneCode(onSuccess) {
    let data = new FormData(phoneModal.formElement)
    data.delete('code')

    axios.post('/api/auth/sign-in/phone', data)
        .then(result => {
            let response = result.data
            if (response.success) {
                setTimer(response.expiresAfterInSeconds)
                onSuccess()
            }
        })
        .catch(error => {
            let message = '', errors = error.response?.data?.errors
            for (let key in errors) {
                if (errors.hasOwnProperty(key)) {
                    message += errors[key].map(error => `<p>${error}</p>`).join('')
                }
            }
            message && phoneModal.notify.error(message)
        })
}

function requirePhoneCode() {
    return new Promise(resolve => {
        phoneModal
            .run(
                () => {
                    phoneModal.notify.clear()
                    sendPhoneCode(resolve)
                }
            )
    })

}

function login() {
    return new Promise(resolve => {
        phoneModal
            .enableCodeInput()
            .run(
                () => {
                    phoneModal.notify.clear()
                    axios.post('/api/auth/sign-in/phone', new FormData(phoneModal.formElement))
                        .then(result => {
                            let response = result.data
                            if (response.success) {
                                window.location.reload()
                            }
                        })
                        .catch(error => {
                            let message = '', errors = error.response?.data?.errors
                            for (let key in errors) {
                                if (errors.hasOwnProperty(key)) {
                                    message += errors[key].map(error => `<p>${error}</p>`).join('')
                                }
                            }
                            message && phoneModal.notify.error(message)
                        })
                },
                () => sendPhoneCode(),
                false
            )
    })
}
